/** Display options for a loading indicator/spinner overlay, including sizing, positioning, and loading text. */
export class LoaderProperties {
    isOpaque?: boolean;
    isFull?: boolean;
    isPositionStatic?: boolean;
    loaderText?: string;
    height?: string;
    width?: string;
    fontSize?: string;
    containerHeight?: string;

    /**
     * Creates a LoaderProperties instance with default non-opaque, non-full, non-static-position styling, "Loading..." text, 75% height/width, and 16px font size.
     */
    constructor() {
        this.isOpaque = false;
        this.isFull = false;
        this.isPositionStatic = false;
        this.loaderText = "Loading...";
        this.height = "75%";
        this.width = "75%";
        this.fontSize = "16px";
    }
}
